import React from 'react';
import { Badge, Body1Strong, Text } from '@fluentui/react-components';
import { Checkmark16Filled, CheckmarkCircle20Filled, Dismiss16Filled, DismissCircle20Filled } from "@fluentui/react-icons";
import { Stack } from '@fluentui/react';

interface PasswordRule {
    description: string;
    check: (password: string) => boolean;
}

const passwordRules: PasswordRule[] = [
    { description: 'At least one letter', check: (password) => /[a-zA-Z]/.test(password) },
    { description: 'At least one capital letter', check: (password) => /[A-Z]/.test(password) },
    { description: 'At least one number', check: (password) => /\d/.test(password) },
    // { description: 'At least 3 numbers', check: (password) => (password.match(/\d/g) || []).length >= 3 },
    { description: 'At least one special character', check: (password) => /[\W_]/.test(password) },
    { description: 'Be at least 8 characters', check: (password) => password.length >= 8 },
];

const checkPasswordStrength = (password: string) => {
    const passedRules = passwordRules.filter(rule => rule.check(password));
    const strength = passedRules.length;

    let strengthText = '';
    let strengthColor: 'severe' | 'danger' | 'warning' | 'success' = 'severe';

    if (strength === 0) { strengthText = 'Very Weak'; strengthColor = 'severe'; }
    else if (strength <= 2) { strengthText = 'Weak'; strengthColor = 'danger'; }
    else if (strength <= 4) { strengthText = 'Moderate'; strengthColor = 'warning'; }
    else { strengthText = 'Strong'; strengthColor = 'success'; }

    return { strengthText, strengthColor, passedRules };
};

interface PasswordStrengthIndicatorProps {
    password: string;
}

const PasswordStrengthIndicator: React.FC<PasswordStrengthIndicatorProps> = ({ password }) => {
    const { strengthText, strengthColor, passedRules } = checkPasswordStrength(password);

    const renderRuleItem = (rule: PasswordRule, index: number) => (
        <Stack horizontal tokens={{ childrenGap: 5 }} key={index}>
            {passedRules.includes(rule) ? (
                <CheckmarkCircle20Filled primaryFill="green" />
            ) : (
                <DismissCircle20Filled primaryFill="red" />
            )}
            <Text>{rule.description}</Text>
        </Stack>
    );

    return (
        <Stack tokens={{ childrenGap: 10 }}>
      <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 5 }}>
      <Body1Strong>Password Status:</Body1Strong>
        <Badge appearance="ghost" color={strengthColor}>
          {strengthText}
        </Badge>
        {/* <Text weight="semibold" color={strengthColor}>{strengthText}</Text> */}
      </Stack>
      <Stack horizontal tokens={{ childrenGap: 20 }}>
        <Stack tokens={{ childrenGap: 5 }}>
          {passwordRules.slice(0, 3).map(renderRuleItem)}
        </Stack>
        <Stack tokens={{ childrenGap: 5 }}>
          {passwordRules.slice(3).map(renderRuleItem)}
        </Stack>
      </Stack>
    </Stack>
    );
};

export default PasswordStrengthIndicator;